import { useEffect } from 'react';
import { useAuth } from 'providers/AuthProvider';
import { isElectron } from 'utils/environment';
import { onLogoutCleanup, registerLogoutStorageSurvivor } from 'utils/logoutCleanup';
import { setAmbossDataGateUser } from './ambossDataGate';
import { resetAmbossSessionState } from './ambossSessionState';
import { AMBOSS_HISTORY_STORAGE_KEY } from './useAmbossHistory';

// Headless component tying the AMBOSS lifecycle to auth events without
// AuthProvider knowing about AMBOSS.
export function AmbossAuthLifecycle() {
  const { user } = useAuth();

  useEffect(() => {
    const unsubscribeReset = onLogoutCleanup(resetAmbossSessionState);
    const unregisterSurvivor = isElectron
      ? registerLogoutStorageSurvivor(AMBOSS_HISTORY_STORAGE_KEY)
      : undefined;
    return () => {
      unsubscribeReset();
      unregisterSurvivor?.();
    };
  }, []);

  useEffect(() => {
    setAmbossDataGateUser(user?.email ?? null);
  }, [user?.email]);

  return null;
}
